import PropTypes from "prop-types";
import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";

import { Button } from "../Button";
import { Image } from "../Image";

import "./styles.scss";

export const BrowseButton = ({ disabled, onClick, testId, ...props }) => (
  <Button
    className="apti-BrowseButton"
    disabled={disabled}
    name="browse-button"
    onClick={onClick}
    type="button"
    {...testLocator(testId)}
    {...props}
  >
    <>
      <Image alt="folder" src="icons/folder.svg" />
      Browse
    </>
  </Button>
);

BrowseButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

BrowseButton.defaultProps = {
  disabled: false,
  onClick: () => {},
  testId: undefined,
};
